import {
  Paragraph2,
  Paragraph3,
  Paragraph4,
} from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import DeliveryTruck from '../../tabs/images/delivery.svg';
import styled from '../../../../../theme/styled';
import { mq } from '../../../../../commons/styles';

const ReturnMethodContainer = styled.div`
  padding-top: ${({ theme }) => theme.space[16]};

  ${mq.desktop} {
    padding-top: ${({ theme }) => theme.space[10]};
  }
`;

const DropOffPointDetails = styled.div`
  padding-bottom: ${({ theme }) => theme.space[16]};
`;

const BlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: ${({ theme }) => theme.fontWeights[500]};
`;

const PackageSizeBlock = styled.div<{ designForD2D: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[8]};
  padding-left: 0;
  padding-right: 0;
  padding-top: ${({ theme }) => theme.space[16]};
  padding-bottom: ${props => (props.designForD2D ? 0 : props.theme.space[16])};
  border-bottom-width: ${props => (props.designForD2D ? '0' : '1px')};
  border-bottom-style: ${props => (props.designForD2D ? 'none' : 'solid')};
  border-bottom-color: ${props =>
    props.designForD2D ? '' : props.theme.colors['borders-global-tertiary']};
`;

const PickupTitle = styled(Paragraph4)`
  font-weight: 500;
`;

const PackageSizeBlockHeader = styled(Paragraph3)`
  color: ${({ theme }) => theme.colors['text-global-secondary']};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  line-height: ${({ theme }) => theme.lineHeights[18]};
`;

const NormalP3 = styled(Paragraph3)`
  font-weight: ${({ theme }) => theme.fontWeights[400]};
  color: ${({ theme }) => theme.colors['text-brand-primary']};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  line-height: ${({ theme }) => theme.lineHeights[18]};
`;

const LightP4 = styled(Paragraph4)`
  color: ${({ theme }) => theme.colors['text-global-secondary']};
  font-size: ${({ theme }) => theme.fontSizes[12]};
  line-height: ${({ theme }) => theme.lineHeights[14]};

  > a {
    color: ${({ theme }) => theme.colors['text-global-secondary']};
  }
`;

const TruckIcon = styled(DeliveryTruck)`
  width: ${({ theme }) => theme.sizes[48]};
`;

const TrackingNumberContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[10]};
  padding-top: ${({ theme }) => theme.space[6]};
`;

const LinkToTrack = styled(LinkParagraph)`
  color: ${({ theme }) => theme.colors['text-brand-alternative']};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  font-weight: normal;
  cursor: pointer;
`;

const DownloadLabelParagraph = styled(Paragraph3)`
  font-weight: ${({ theme }) => theme.fontWeights[500]};
  padding-top: ${({ theme }) => theme.space[16]};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  line-height: ${({ theme }) => theme.lineHeights[18]};
`;

const PackagePointDetail = styled(Paragraph4)`
  padding-bottom: ${({ theme }) => theme.space[8]};
  font-size: ${({ theme }) => theme.fontSizes[12]};
  line-height: ${({ theme }) => theme.lineHeights[14]};
  color: ${({ theme }) => theme.colors['text-global-disabled']};
`;

const ProviderName = styled(Paragraph2)`
  text-transform: capitalize;
`;

export default {
  ReturnMethodContainer,
  DropOffPointDetails,
  BlockHeader,
  PackagePointDetail,
  PackageSizeBlock,
  PickupTitle,
  PackageSizeBlockHeader,
  NormalP3,
  LightP4,
  TruckIcon,
  TrackingNumberContainer,
  LinkToTrack,
  DownloadLabelParagraph,
  ProviderName,
};
